import React from 'react';
import { Col, Container, Row, Accordion } from 'react-bootstrap';
import { map, times } from 'lodash';
import { useTranslation } from 'react-i18next';

const FrequentlyAskedQuestionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <h2 className="text-center">{t('healthInsurancePage.frequentlyAskedQuestionSection.title')}</h2>
      <Container>
        <Row>
          <Col lg={10} className="mx-auto">
            <Accordion flush>
              {map(times(7), (idx) => (
                <Accordion.Item
                  eventKey={t(`healthInsurancePage.frequentlyAskedQuestionSection.q${idx + 1}`)}
                  key={`fqa${idx + 1}`}
                >
                  <Accordion.Header>
                    <span className="fw-bold">
                      {t(`healthInsurancePage.frequentlyAskedQuestionSection.q${idx + 1}`)}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={{ whiteSpace: 'pre-line' }}>
                    {t(`healthInsurancePage.frequentlyAskedQuestionSection.a${idx + 1}`)}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { FrequentlyAskedQuestionSection };
